// pages/Team.js
import React from 'react';
// import '../styles/Team.css';

const team = [
  {
    id: 1,
    name: "John Doe",
    position: "CEO & Founder",
    image: "/api/placeholder/200/200",
    bio: "20+ years in EdTech",
    social: {
      linkedin: "#",
      twitter: "#"
    }
  },
  // Add more team members
];

export default function Team() {
  return (
    <div className="team">
      <section className="team-hero">
        <h1>Meet Our Team</h1>
        <p>Passionate educators and technologists</p>
      </section>

      <div className="team-grid">
        {team.map(member => (
          <div key={member.id} className="team-card">
            <div className="member-image">
              <img src={member.image} alt={member.name} />
            </div>
            <div className="member-info">
              <h3>{member.name}</h3>
              <span className="position">{member.position}</span>
              <p>{member.bio}</p>
              <div className="social-links">
                <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer">LinkedIn</a>
                <a href={member.social.twitter} target="_blank" rel="noopener noreferrer">Twitter</a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}